import { Platform } from 'react-native';

// Sesli aramanın açık/kapalı olması (9.4.13).
//
// Akışın tamamı yazılı ve ses gerçekten taşınabiliyor (D-087), ama bir ön koşul
// daha var: TURN sunucusu (9.4.4.2 — coturn). TURN'süz kurulum yalnız elverişli
// ağlarda (aynı LAN, basit NAT) çalışır; simetrik NAT ya da kurumsal ağda çağrı
// hiç kurulmaz. Ücret ise kabul anında işlemeye başlar (9.4.2.3), yani
// kurulamayan ya da sessiz bir çağrı için para almak riski gerçek.
//
// D-097 ile TURN + gerçek cihaz medyası uçtan uca doğrulandı; 9.4.13 kapandı.
// Bu yüzden arama mobilde artık varsayılan açık. Bayrak acil geri-kapama kapısıdır;
// web ise ayrıca doğrulanmadan kendiliğinden açılmaz (açıkça `true` verilirse açılır).
// Native WebRTC modülü yoksa ikinci kapı (`mediaAvailable`) butonu yine çizmez.
const flag = process.env.EXPO_PUBLIC_CALLS_ENABLED;
export const callsEnabled = flag === 'true' || (flag !== 'false' && Platform.OS !== 'web');

// Görüntülü aramanın giriş noktasının çizilip çizilmeyeceği (9.4.14).
//
// Sesli aramadan ayrı bir kapı, çünkü ön koşulu ayrı: görüntüyü çizen
// `CallVideo` web'de bilerek `null` döner (tarayıcıda akış `<video>`
// elementine bağlanır, o da RN'in JSX'inde yok). Web'de görüntülü aramayı
// açmak, kullanıcıdan görüntü ücreti alıp ekranda hiçbir şey göstermemek
// olurdu. Bu yüzden kapı `callsEnabled`'ın altına değil, yanına konuyor:
// sesli arama web'de açılabilir, görüntülü açılamaz.
export const videoCallsSupported = Platform.OS !== 'web';
